module.exports = __webpack_public_path__ + "static/img/汇码付logo1.047cbba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/汇码付logo1.png
// module id = YTxO
// module chunks = 15